export const Index_item = [
  {
    id: 1,
    compName: '互勾聊天',
    title: '互勾·聊天',
    conetent: [
      {
        title: '「即时通讯」：',
        descript: '好友聊天，消息即时到达。'
      },
      {
        title: '「视频通话」：',
        descript: '多人通话，面对面沟通。'
      },
      {
        title: '「分组管理」：',
        descript: '复杂关系，简单化。'
      },
      {
        title: '「群内私聊」：',
        descript: '全新@功能，仅@成员可见。'
      }
    ],
    slogan: '打破一切沟通障碍',
    qrcodeImg: 'qrcode_im.png',
    iOSUrl: 'https://apps.apple.com/cn/app/id1312731800',
    androidUrl: 'https://app.tikfriend.com/down/hugou_im.apk'
  },
  {
    id: 2,
    compName: '互勾办公',
    title: '互勾·办公',
    conetent: [
      {
        title: '',
        descript: '你的机构，由你掌控。致力于提高老板的管理效率，是你便捷生活、高效办公的得力助手。'
      },
      {
        title: '',
        descript: '特色：机构账号的概念：员工的所有聊天记录及其客户关系都可监管。'
      },
      {
        title: '「即时通讯」：',
        descript: '支持发送文本、图片、语音、视频，定时撤回消息。'
      },
      {
        title: '「群聊私聊」：',
        descript: '全新@功能，可选择@部分成员私密聊天，无需为临时需求创建多个群组。'
      },
      {
        title: '「通讯录」：',
        descript: '按组织架构查看机构成员信息，获取部门主管、部人员岗位、人员联系方式。'
      },
      {
        title: '「考勤打卡」：',
        descript: '员工考勤打卡，管理员设置考勤打卡。'
      },
      {
        title: '「审批」：',
        descript: '灵活设置审批流程，满足机构各类流程流程审批。'
      },
      {
        title: '「办公网盘」：',
        descript: '文件安全设置，强大权限配置，支持文件预览、上传、下载、移动、复制、隐藏分享操作。'
      },
    ],
    slogan: '你的机构，由你掌控',
    qrcodeImg: 'qrcode_work.png',
    iOSUrl: 'https://apps.apple.com/cn/app/id1529573416',
    androidUrl: 'https://app.tikfriend.com/down/hugou_work.apk',
    windowsUrl: 'https://app.tikfriend.com/down/hugou_work_windows.exe'
  },
  {
    id: 3,
    compName: '互勾动态',
    title: '互勾·动态',
    conetent: [
      {
        title: '',
        descript: '多个不同模块自由组合形成个性化动态，记录你多彩的生活。'
      },
      {
        title: '1、',
        descript: '支持选择模版发布不同类型的动态。'
      },
      {
        title: '2、',
        descript: '支持多个不同模块自由组合形成个性化动态，记录你多彩的生活。'
      },
      {
        title: '3、',
        descript: '支持发起各类活动，聚会派对等，让你的生活更加丰富。'
      },
      {
        title: '4、',
        descript: '支持上传照片墙，制作专属于你的独家记忆。'
      },
      {
        title: '5、',
        descript: '全世界/好友发布、分享的动态，看看不同的世界。'
      },
      {
        title: '6、',
        descript: '全支持有声朗读，听见快乐的时光'
      },
    ],
    slogan: '活在当下，及时行乐',
    qrcodeImg: 'qrcode_comment.png',
    iOSUrl: 'https://apps.apple.com/cn/app/id1526259973',
    androidUrl: 'https://app.tikfriend.com/down/hugou_comment.apk'
  },
  {
    id: 4,
    compName: '互勾收藏',
    title: '互勾·收藏',
    conetent: [
      {
        title: '',
        descript: '一款个人云服务产品，使用互勾收藏，领取超大空间，相册、文件、视频、音频全部收藏，注册就送10G免费容量。'
      },
      {
        title: '「传输功能」：',
        descript: '上传下载速度飞快。支持断点续传。超大文件上传下载。'
      },
      {
        title: '「私密空间」：',
        descript: '全不同密码，不同私密空间，守护你心中的小秘密。'
      },
      {
        title: '「分享功能」：',
        descript: '世间美好，值得分享，分享出你的精彩。'
      },
    ],
    slogan: '世间美好，尽在收藏',
    qrcodeImg: 'qrcode_goudrive.png',
    iOSUrl: 'https://apps.apple.com/cn/app/id1530123036',
    androidUrl: 'https://app.tikfriend.com/down/hugou_goudrive.apk'
  }
]



//////////////////
// WEBPACK FOOTER
// ./static/hugouJson.js
// module id = null
// module chunks = 